import { FC } from "react";

import { useFullUserProfileContext } from "Bands/contexts";
import { copy } from "shared/assets";
import { Loader, PassportTeaser, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { useFetchingUserDocuments } from "Bands/utils";
import { GridContainer } from "shared/styles";

const passportCopy = copy.userPassport;

export const Passports: FC = () => {
  const { passports } = useFullUserProfileContext();

  const { fetchingPassports } = useFetchingUserDocuments();

  if (fetchingPassports) return <Loader />;
  if (!passports?.length) return null;

  return (
    <Spacer size="m">
      <Title title={passportCopy.title} asComponent="h3" size="s" />
      <GridContainer>
        {passports?.map(passport => (
          <PassportTeaser key={passport.id} {...passport} />
        ))}
      </GridContainer>
    </Spacer>
  );
};
